import $api from "..";
import { AxiosResponse } from "axios";
import { IDashBoard } from "../common/api_interfaces/board/IDashBoard";
import { IAllStatusColumn } from "../common/api_interfaces/column/IAllStatusColumn";
import { IDashBoardEditReq } from "../common/api_interfaces/board/IDashBoardEditReq";
import { IColumnDisplay } from "../common/api_interfaces/column/IColumnDisplay";
import { IColumn } from "../common/api_interfaces/column/IColumn";
import { IDeleteBoard } from "../common/api_interfaces/board/IDeleteBoard";
import { ICreateBoardRequest } from "../common/api_interfaces/board/ICreateBoardRequest";

export default class DashBoardService {
    async getAllStatusColumn(boardId: number): Promise<AxiosResponse<IAllStatusColumn[]>> {
        return $api.get<IAllStatusColumn[]>(`/system/getStatusVariants`);
    }

    static async addDashBoard(body: ICreateBoardRequest): Promise<AxiosResponse<void>> {
        return $api.post<void>("board/add", body);
    }

    async getProjectBoards(projectId: number): Promise<AxiosResponse<IDashBoard[]>> {
        return $api.get<IDashBoard[]>(`/Project/${projectId}/boards`);
    }

    static async getProjectIdDashBoards(id: number): Promise<AxiosResponse<number>> {
        return $api.get<number>(`/project/getIdByBoardId?boardId=${id}`);
    }

    async getColumns(boardId: number): Promise<AxiosResponse<IColumn[]>> {
        return $api.get<IColumn[]>(`/board/${boardId}/columns`);
    }

    static async getAllColumnBoard(id: number): Promise<AxiosResponse<IColumnDisplay[]>> {
        return $api.post<IColumnDisplay[]>(`/board/${id}/getColumnsWithTasks`);
    }

    static async deleteBoard(body: IDeleteBoard): Promise<void> {
        return $api.post("board/delete", body);
    }

    static async editBoard(body: IDashBoardEditReq): Promise<void> {
        return $api.post("/board/edit", body);
    }

    static async st(): Promise<void> {
        return $api.get("/st");
    }
}
